module.exports = __webpack_public_path__ + "assets/352983c1b7e4f586add7a348a6ccef1c.mp3";